import React from 'react'
import { BrowserRouter } from 'react-router-dom'

import { BROWSER_ROUTER_BASENAME } from '../../config/config'
import { AuthenticateProvider } from '../../hooks/useAuthenticate'
import { PaymentDataProvider } from '../../hooks/usePaymentData'
import { MainContent } from './MainContent'

const Main: React.FC = () => {
  return (
    <BrowserRouter basename={BROWSER_ROUTER_BASENAME}>
      <PaymentDataProvider>
        <AuthenticateProvider>
          <MainContent />
        </AuthenticateProvider>
      </PaymentDataProvider>
    </BrowserRouter>
  )
}

export default Main
